<template>
<div class="swipe">
  <swiper :options="swiperOption">
    <swiper-slide v-for="item,index in imgArr" :key='index' class="swiper-slide"><img :src="item.src" v-if="!item.pic" />
      <img :src="imgUrl + item.pic" v-else>
      <div class="container">
        <div class="content" v-if="!item.pic">
          <h3 class="h3">我们致力于使商业的信息交流</h3>
          <h4>无地域限制 无空间限制 无行业限制</h4>
          <p>让您以光速获得有价值的商业信息。</p>
          <p>打造宇宙级的商业信息交流平台。</p>
          <router-link to="">立即体验 <img src="../assets/images/arrow_right.png" alt=""></router-link>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {
  banner
} from "../api/api"
const imgArr = [{
  src: require('../assets/images/banner.jpg')
}, {
  src: require('../assets/images/banner.jpg')
}, {
  src: require('../assets/images/banner.jpg')
}];
export default {
  name: 'swipe',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 5000,
        // height: 911,
        // width: 1920
      },
      imgArr: imgArr,
      imgUrl: imgUrl,
    }
  },
  mounted() {
     this.imgArr = sessionStorage.getItem("imgArr")
    this.getbanner();

  },
  methods: {
    getbanner() {
      
      banner({
        type: 2
      }).then(res => {
        if (res.data.code == 200) {

          this.imgArr = res.data.result
          sessionStorage.setItem("imgArr", this.imgArr );
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.swipe {
  overflow: hidden;
  position: relative;
}

.swipe-slide {
  position: relative;
}

.content {
  position: absolute;
  top: 30%;
  color: #ffffff;
  line-height: 1.8;

  h3 {
    font-size: 38px;
    font-weight: bold;
  }

  h4 {
    margin-bottom: 10px;
    font-size: 27px;
    font-weight: bold;
  }

  p {
    font-size: 18px;
    color: #fffefe;
  }

  a {
    display: inline-block;
    margin-top: 60px;
    font-size: 16px;
    color: #fffefe;
    padding: 5px 27px;
    border: 1px solid #2595d7;
    border-radius: 2px;
    transition: all 0.3s;

    &:hover {
      background-color: #2595d7;
    }

    img {
      margin-left: 5px;
      width: 12px;
      height: 12px;
    }
  }
}

img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue